import React, { useContext } from 'react'

import { NotificationContextValue } from '../../types'

export const NotificationContext = React.createContext<NotificationContextValue>({
  notifPayload: null,
  showSuccessNotif: () => {},
  showErrorNotif: () => {},
  showInfoNotif: () => {},
  showNotif: () => {},
  hideNotif: () => {}
})
const useNotification = () => useContext(NotificationContext)!

export default useNotification
